import { IoStar } from 'react-icons/io5';

const Star = ({className}) => {
    return <IoStar className={className ? className : 'color-orange-4'}/>
};

export default Star;